import { useLocation } from "react-router-dom";
import { useSecurityContext } from "./useSecurityContext";

export function useModoSomenteLeitura() {
  const { hasPermission } = useSecurityContext();
  const location = useLocation();

  // Se a navegação explicitamente abriu em modo visualização
  if (location?.state?.modoSomenteLeitura === true) {
    return true;
  }

  // Roles que podem alterar os dados
  const podeEditar = hasPermission({
    hasAnyRole: [
      "ROLE_CENSO_GERENCIA",
      "ROLE_CENSO_ATENDENTE",
      "ROLE_CENSO_ATENDENTE_GOIASPREV",
    ],
  });

  return !podeEditar;
}
